export default {
  introSteps: {
    exportFile: 'Нөгөө Arena серверээс (жишээ нь Dev эсвэл QA) судалгааг өгөгдөлгүйгээр экспортлоно',
    selectFile: 'Экспортолсон файлыг (.zip) сонгоно: түүнийг энэ судалгаатай харьцуулж, ялгааг харуулна',
    applyChanges:
      'Ялгааг шалгаад сонгосон өөрчлөлтүүдийг энэ судалгаанд хэрэгжүүлнэ (устгалыг анхдагчаар хэзээ ч сонгохгүй)',
    publish: 'Өөрчлөлтүүд ноорог хэлбэрээр хадгалагдана: маягтыг шалгаад судалгааг нийтэлснээр хүчин төгөлдөр болно',
  },
  fileTooLarge:
    'Сонгосон файл хэт том байна (дээд тал нь {{maxSize}} MB): судалгааг өгөгдөлгүйгээр экспортлоно уу, судалгааг харьцуулахад бүртгэлүүд болон тэдгээрийн файлууд шаардлагагүй',
  selectNewSource: 'Шинэ эх сурвалж сонгох',
  selectNewSourceInfo: 'Энэ харьцуулалтыг цуцалж, өөр судалгааны файл эсвэл судалгаа сонгох',
  refreshComparison: 'Харьцуулалтыг шинэчлэх',
  refreshComparisonInfo:
    'Ижил файлыг энэ судалгааны одоогийн хувилбартай дахин харьцуулах (жишээ нь засварласны дараа)',
  sourceSurvey: 'Харьцуулсан судалгаа: {{name}}',
  compareWithSurvey: 'Эсвэл энэ сервер дээрх өөр судалгаатай харьцуулах:',
  fingerprint: {
    thisSurvey: 'Энэ судалгаа',
    comparedSurvey: 'Харьцуулсан судалгаа',
    equal: 'Энэ судалгаатай ижил',
    different: 'Энэ судалгаанаас ялгаатай',
    label: 'Хурууны хээ',
    structural: 'бүтцийн',
    info: 'Судалгааны тодорхойлолтын (ноорог) хурууны хээ. Ижил хурууны хээ нь ижил тодорхойлолтыг илэрхийлнэ. Эхнийх нь дотоод ID-уудыг агуулдаг: зөвхөн нэг судалгааны хуулбарын хувьд (жишээ нь өөр сервер рүү экспортолж импортолсон) ижил байна. Бүтцийн хээ нь нэр болон кодыг ашигладаг: ижил бүтэцтэй тусад нь үүсгэсэн судалгааны хувьд ч ижил байна. Нэр, шошго, ID, огноо болон нийтлэлийн төлөв үүнд ордоггүй.',
    copy: 'Хурууны хээг бүтнээр нь хуулах: {{value}}',
    copied: 'Хурууны хээг санах ой руу хууллаа',
  },
  identical: 'Судалгаанууд ижил байна',
  counts: 'Зөвхөн харьцуулсан судалгаанд {{added}}, өөрчлөгдсөн {{changed}}, зөвхөн энэ судалгаанд {{removed}}',
  surveyInfoChanged: 'Судалгааны мэдээлэл (хэл, мөчлөг, шошго) ялгаатай байна: "Судалгааны мэдээлэл" табыг харна уу',
  onlyDifferences: 'Зөвхөн ялгааг харуулах',
  hideLayoutOnly: 'Зөвхөн байршлын ялгааг нуух',
  apply: 'Сонгосон өөрчлөлтүүдийг хэрэгжүүлэх ({{count}})',
  applyConfirm: `Сонгосон {{count}} өөрчлөлтийг энэ судалгаанд хэрэгжүүлэх үү?
Өөрчлөлтүүд ноорог хэлбэрээр хадгалагдах бөгөөд судалгааг нийтэлсний дараа л бүртгэлүүдэд хамаарна.`,
  willBeDeleted: 'устгагдана',
  removedNodeDefInfo:
    'Энэ зангилааны тодорхойлолт зөвхөн энэ судалгаанд байна: энэ өөрчлөлтийг хэрэгжүүлбэл түүнийг (удамшсан элементүүдийн хамт) энэ судалгаанаас устгана.',
  removedItemInfo: 'Зөвхөн энэ судалгаанд: энэ өөрчлөлтийг хэрэгжүүлбэл түүнийг энэ судалгаанаас устгана.',
  applyConfirmWithDeletionsHeader: 'Устгалыг баталгаажуулах',
  applyConfirmWithDeletions:
    'Сонгосон {{count}} өөрчлөлтийг энэ судалгаанд хэрэгжүүлэх үү?\n\n**Эдгээрийн {{deletionsCount}} нь энэ судалгааны элементүүдийг устгана** (харьцуулсан судалгаанд байхгүй элементүүд):\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)',
  applyWithDeletions: 'Хэрэгжүүлж устгах',
  confirmSurveyName: 'Баталгаажуулахын тулд энэ судалгааны нэрийг оруулна уу:',
  deletionOfItemsOf: '**{{name}}**-ийн зөвхөн энэ судалгаанд байгаа элементүүд',
  moreDeletions: '... болон өөр {{count}}',
  applyCompleted:
    'Хэрэгжүүлсэн өөрчлөлт: {{applied}}, алгассан: {{skipped}}. Хүчин төгөлдөр болгохын тулд судалгааг нийтэлнэ үү.',
  tabs: {
    nodeDefs: 'Зангилааны тодорхойлолтууд',
    categories: 'Ангилалууд',
    taxonomies: 'Таксономиуд',
    surveyInfo: 'Судалгааны мэдээлэл',
    surveyFiles: 'Файлууд',
  },
  status: {
    added: 'Зөвхөн харьцуулсан судалгаанд',
    changed: 'Өөрчлөгдсөн',
    removed: 'Зөвхөн энэ судалгаанд',
  },
  statusLabel: 'Төлөв',
  matchedBy: {
    uuid: 'Дотоод ID-аар тохирсон',
    name: 'Нэрээр тохирсон (дотоод ID-ууд өөр)',
    manual: 'Гараар тохируулсан: нэр өөрчлөлт болгон хэрэгжүүлнэ',
  },
  renameCandidate: 'Энэ судалгааны "{{name}}"-ийн нэрийг өөрчилсөн байж магадгүй',
  possibleRename: 'нэр өөрчилсөн байж магадгүй',
  matchAsRename: 'Нэр өөрчилсөн гэж тохируулах',
  unmatch: 'Тохируулгыг цуцлах',
  props: {
    branding: 'Брэндинг',
    columnsNo: 'Баганууд',
    columnsOrder: 'Баганын дараалал',
    cycles: 'Мөчлөгүүд',
    defaultCycleKey: 'Анхдагч мөчлөг',
    descriptions: 'Тайлбарууд',
    extra: 'Нэмэлт шинж чанарууд',
    family: 'Овог',
    fieldManualLinks: 'Талбайн гарын авлагын холбоосууд',
    formLayout: 'Маягтын байршил',
    genus: 'Төрөл',
    gridPosition: 'мөр {{row}}, багана {{column}}, өргөн {{width}}, өндөр {{height}}',
    itemExtraDef: 'Нэмэлт шинж чанарууд',
    keepNonApplicableValues: 'Хамааралгүй утгуудыг хадгалах',
    labels: 'Шошгууд',
    languages: 'Хэлнүүд',
    layout: 'Байршил',
    levels: 'Түвшингүүд',
    messages: 'Мессежүүд',
    pagesOrder: 'Хуудасны дараалал',
    parent: 'Эцэг объект',
    preloadedMapLayersEnabled: 'Урьдчилан ачаалсан газрын зургийн давхаргууд идэвхжсэн',
    reportingData: 'Тайлагнах өгөгдөл',
    sampleBasedImageInterpretationEnabled: 'Дээж дээр суурилсан зураг тайлбарлах',
    samplingPolygon: 'Түүвэрлэх олон өнцөгт',
    scientificName: 'Шинжлэх ухааны нэр',
    size: 'Хэмжээ',
    srs: 'Орон зайн лавлах системүүд',
    surveyDocOptions: 'Судалгааны баримт бичгийн тохиргоо',
    userExtraPropDefs: 'Хэрэглэгчийн нэмэлт шинж чанарууд',
    validations: 'Баталгаажуулалт',
    vernacularLanguageCodes: 'Нутаг усны нэрсийн хэлнүүд',
    vernacularNames: 'Нутаг усны нэрс',
  },
  fileTypes: {
    preloadedMapLayer: 'Урьдчилан ачаалсан газрын зургийн давхарга',
    surveyDocImage: 'Судалгааны баримт бичгийн зураг',
    brandingSurveyLogo1: 'Судалгааны лого 1',
    brandingSurveyLogo2: 'Судалгааны лого 2',
    brandingSurveyLogo3: 'Судалгааны лого 3',
    brandingLandingBackground: 'Нүүр хуудасны дэвсгэр',
  },
  cycle: 'мөчлөг {{cycle}}',
  property: 'Шинж чанар',
  sourceValue: 'Харьцуулсан судалгаа',
  targetValue: 'Энэ судалгаа',
  emptyValue: '(хоосон)',
  layoutOnly: 'зөвхөн байршил',
  selectItem: 'Дэлгэрэнгүйг харахын тулд зүйл сонгоно уу',
  noDifferences: 'Ялгаа байхгүй',
  identicalItem: 'Ялгаа байхгүй',
  dependsOn: 'Хамт хэрэгжүүлэх:',
  itemsCount: 'зүйлс: {{added}} нэмэгдсэн, {{changed}} өөрчлөгдсөн, {{removed}} зөвхөн энэ судалгаанд',
  itemCode: 'Код',
  taxaCount: 'таксонууд: {{added}} нэмэгдсэн, {{changed}} өөрчлөгдсөн, {{removed}} зөвхөн энэ судалгаанд',
  taxonCode: 'Код',
  changes: 'Өөрчлөлтүүд',
  moreItems: '... болон өөр {{count}} зүйл',
  categoryRemoval: 'Зөвхөн энэ судалгаанд байгаа зүйлс (болон түвшингүүд)-ийг устгах',
  taxonomyRemoval: 'Зөвхөн энэ судалгаанд байгаа таксонууд болон нутаг усны нэрсийг устгах',
  removalSelected: 'устгахаар сонгосон',
  publishedKept: '(нийтлэгдсэн: хадгална)',
  reasons: {
    categoryInUse: 'Ангиллыг устгагдаагүй зангилааны тодорхойлолтууд ашиглаж байна',
    categoryMissing: 'Энэ судалгаанд ангилал байхгүй байна',
    cycleMissing: 'Энэ судалгаанд мөчлөг дутуу байна',
    dependencyNotApplicable: 'Хамааралтай өөрчлөлтийг хэрэгжүүлэх боломжгүй',
    parentMissing: 'Эцэг зангилааны тодорхойлолт энэ судалгаанд байхгүй байна',
    publishedCategoryChanged: 'Нийтлэгдсэн зангилааны тодорхойлолтын ангиллыг өөрчлөх боломжгүй',
    publishedKeyChanged: 'Нийтлэгдсэн зангилааны тодорхойлолтын "түлхүүр" шинж чанарыг өөрчлөх боломжгүй',
    publishedMoveNotSupported: 'Нийтлэгдсэн зангилааны тодорхойлолтыг өөр объект руу зөөх боломжгүй',
    publishedMultipleChanged: 'Нийтлэгдсэн зангилааны тодорхойлолтын "олон" шинж чанарыг өөрчлөх боломжгүй',
    publishedTaxonomyChanged: 'Нийтлэгдсэн зангилааны тодорхойлолтын таксономийг өөрчлөх боломжгүй',
    publishedTypeChanged: 'Нийтлэгдсэн зангилааны тодорхойлолтын төрлийг өөрчлөх боломжгүй',
    taxonomyInUse: 'Таксономийг устгагдаагүй зангилааны тодорхойлолтууд ашиглаж байна',
    taxonomyMissing: 'Энэ судалгаанд таксономи байхгүй байна',
    nodeDefUsedByOthers:
      'Бусад зангилааны тодорхойлолтууд үүнийг илэрхийлэлдээ ашиглаж байна: тэдгээрийг мөн шинэчилнэ үү',
    publishedCategoryItemsKept: 'Нийтлэгдсэн зүйлсийг устгах боломжгүй: тэдгээрийг хадгална',
    publishedCategoryLevelsKept: 'Нийтлэгдсэн түвшингүүдийг устгах боломжгүй: тэдгээрийг хадгална',
    publishedCyclesRemoved: 'Нийтлэгдсэн зангилааны тодорхойлолтоос мөчлөгийг хасвал тухайн мөчлөгүүдийн өгөгдөл устна',
    publishedLanguagesRemoved: 'Хэлийг хасвал судалгааг нийтлэх үед тэдгээрийн шошгууд устна',
    publishedNameChanged:
      'Нийтлэгдсэн зангилааны тодорхойлолтын нэрийг өөрчилж байна: хуучин нэрийг ашигласан илэрхийллүүдийг шинэчлэх шаардлагатай',
    publishedNodeDefDeleted: 'Зангилааны тодорхойлолт нийтлэгдсэн байна: судалгааг нийтлэх үед түүний өгөгдөл устна',
    publishedSurveyCyclesRemoved: 'Мөчлөгийг хасвал судалгааг нийтлэх үед тэдгээрийн бүртгэлүүд устна',
    publishedTaxaKept: 'Нийтлэгдсэн таксонуудыг устгах боломжгүй: тэдгээрийг хадгална',
    publishedVernacularNamesKept: 'Нийтлэгдсэн нутаг усны нэрсийг устгах боломжгүй: тэдгээрийг хадгална',
  },
}
